import React__default from 'react';

const reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return [
                null,
                true,
                null
            ];
        case 'loaded':
            return [
                action.result,
                false,
                null
            ];
        case 'error':
            return [
                null,
                false,
                action.error
            ];
    }
};
function useDynamicModule(loader, name, deps) {
    const [state, dispatch] = React__default.useReducer(reducer, [
        null,
        true,
        null
    ]);
    React__default.useEffect(()=>{
        let current = true;
        dispatch({
            type: 'loading'
        });
        loader().then((mod)=>{
            if (current) {
                dispatch({
                    type: 'loaded',
                    result: mod
                });
            }
        }).catch((error)=>{
            if (current) {
                console.error(`Failed to load dynamic module: ${name}`, error);
                dispatch({
                    type: 'error',
                    error
                });
            }
        });
        return function detach() {
            current = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        ...deps
    ]);
    return state;
}

export { useDynamicModule };
//# sourceMappingURL=use-dynamic-module.js.map
